import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "counter"];
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 320 },
    softMin: { type: Number, default: 150 },
    softMax: { type: Number, default: 160 },
  };

  connect() {
    this.updateCounter();
  }

  updateCounter() {
    const length = this.inputTarget.value.length;
    this.counterTarget.textContent = `${length} / ${this.maxValue} characters`;

    // Remove all status classes
    this.counterTarget.classList.remove(
      "text-base-content",
      "opacity-50",
      "text-success",
      "text-warning",
      "text-error",
    );

    // Apply appropriate class based on character count
    if (length === 0) {
      this.counterTarget.classList.add("text-base-content", "opacity-50");
    } else if (length < this.softMinValue) {
      this.counterTarget.classList.add("text-warning");
    } else if (length >= this.softMinValue && length <= this.softMaxValue) {
      this.counterTarget.classList.add("text-success");
    } else if (length > this.softMaxValue && length <= this.maxValue) {
      this.counterTarget.classList.add("text-warning");
    } else {
      this.counterTarget.classList.add("text-error");
    }
  }
}
